import { webposDe } from './webpos-de';
import { webposEn } from './webpos-en';
import { webposTh } from './webpos-th';

/**
 * WebPOS i18n translations.
 *
 * To register with the main i18n system, add to the app's i18n setup:
 *
 *   import { webPosTranslations } from './webpos/i18n';
 *
 *   i18n.addResourceBundle('de', 'translation', webPosTranslations.de, true, true);
 *   i18n.addResourceBundle('en', 'translation', webPosTranslations.en, true, true);
 *   i18n.addResourceBundle('th', 'translation', webPosTranslations.th, true, true);
 */
export const webPosTranslations = {
  de: webposDe,
  en: webposEn,
  th: webposTh,
};
